module.exports = __webpack_public_path__ + "2cea8cbaaa4de66831c6aff6f356cbfc.svg";